const AWS_API_URL = "https://api.thesmalldatastore.com";
const __is_prod__ = process.env.NODE_ENV === "production";
export const BASE_URL = __is_prod__ ? AWS_API_URL : "http://localhost:5001";

export const ADMIN_URL = `${BASE_URL}/admin`;
export const STORE_URL = `${BASE_URL}/store`;

export const LOGIN = `${ADMIN_URL}/login`;
export const REGISTER = `${ADMIN_URL}/register`;
export const REFRESH = `${ADMIN_URL}/refresh`;
export const LOGOUT = `${ADMIN_URL}/logout`;
export const CREATE_MARKET_SCAN_RECORD = `${ADMIN_URL}/create_market_scan_record`;
export const GET_MARKET_SCAN_RECORDS = `${ADMIN_URL}/get_market_scan_records`;
export const GET_MARKET_SCAN_RECORD_ID = `${ADMIN_URL}/get_market_scan_record`;
export const UPDATE_MARKET_SCAN_RECORD_ID = `${ADMIN_URL}/update_market_scan_record`;

export const STORE_ONBOARD = `${STORE_URL}/create`;
export const DOMAIN_AVAILABLE = `${BASE_URL}/testing/check_domain`